/**
 * RAIL PREFERENCES THAT OUTLIVE A VISIT — the two booleans the navigation
 * rail remembers for the reader, and the only two places it touches storage.
 *
 * They live beside the rail rather than inside it because they are not
 * rendering: they are the persistence layer for `Sidebar.tsx`, read once to
 * seed state and written back on change.
 */

const NAV_COLLAPSED_KEY = 'hadir.nav.collapsed';

export function loadCollapsed(): boolean {
  try {
    return JSON.parse(localStorage.getItem(NAV_COLLAPSED_KEY) || 'false') === true;
  } catch {
    return false;
  }
}

/**
 * WHICH GROUPS THE READER HAS SHUT, remembered between visits.
 *
 * A rail that forgets is a rail you re-tidy every morning, so the answer is
 * persisted. Absent means OPEN: a new group added in a later release appears,
 * rather than inheriting a closed state nobody chose for it.
 *
 * Storage can throw — Safari private mode, a locked-down profile — and a nav
 * that cannot render because it could not read a preference is a worse failure
 * than one that forgets. Both directions swallow.
 */
const NAV_EXPANDED_KEY = 'hadir.nav.expanded';

export function loadExpanded(): Record<string, boolean> {
  try {
    return JSON.parse(localStorage.getItem(NAV_EXPANDED_KEY) || '{}') as Record<string, boolean>;
  } catch {
    return {};
  }
}

export { NAV_COLLAPSED_KEY, NAV_EXPANDED_KEY };
